import { useState } from "react";
import ReviewModal from "./rating-modal";
import { formatDate, isAuthenticated } from "../../utils/helpers";
import { useNavigate } from "react-router-dom";
import RatingGauge from "./RatingGauge";

export function RatingsAndReviews({
  averageRating,
  fetcher,
  businessDetail,
  userReviews,
}) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="p-4 sm:p-6">
      <h2 className="text-[20px] font-bold text-[#232123] mb-4">
        Rating & reviews
      </h2>

      {/* Rating header with inline Rate button */}
      <div className="mb-6">
        <div className="flex items-start justify-between mb-1 max-w-[400px]">
          <div className="flex items-end">
            {/* Star icon */}
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="#FFC107"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                stroke="#FFC107"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="text-[28px] font-bold text-[#232123] ml-4">
              {averageRating}
            </span>
          </div>

          {/* Rate button */}
          <button
            className="px-4 py-1.5 bg-[#7b189f] text-white rounded-md text-[13px] font-medium hover:bg-[#6a1487] transition-colors"
            onClick={() => {
              if (!isAuthenticated()) {
                localStorage.setItem("target", window.location.pathname);
                navigate("/signin");
                return;
              } else {
                setOpen(true);
              }
            }}
          >
            Rate
          </button>
        </div>

        {/* Rating details */}
        <div className="flex items-center text-[13px] text-[#777280]">
          <span>(Quality</span>
          <span className="mx-1">·</span>
          <span>Service</span>
          <span className="mx-1">·</span>
          <span>Price)</span>
          <span className="mx-1.5">·</span>
          <span>Overall {userReviews.length} ratings</span>
        </div>
      </div>

      {/* Review Notice */}
      <div className="bg-[#f8f0ff] p-4 rounded-md mb-6 flex items-start">
        <div className="w-8 h-8 bg-[#f2e8f5] rounded-full flex items-center justify-center flex-shrink-0">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z"
              stroke="#7B189F"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="ml-3">
          <p className="text-[13px] text-[#232123] font-medium">
            Gallyo is committed to showing genuine
          </p>
          <p className="text-[13px] text-[#232123]">
            & verified reviews from neighbours around you
          </p>
        </div>
      </div>

      {/* Reviews */}
      <div className="space-y-6">
        {/* Review 1 */}

        {userReviews.length === 0 ? (
          <p>No reviews yet.</p>
        ) : (
          userReviews.map((review) => (
            <div className="border-b border-[#F5E8EA] pb-6">
              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#f5f3f5] rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={
                      review.avatarurl ||
                      "/image/avatar1.jpg?height=40&width=40"
                    }
                    alt="David M"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="ml-3 flex-1">
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="text-[#232123] text-[15px] font-medium">
                        {review.username}
                      </p>
                      <div className="flex items-center mt-1">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="#FFC107"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                            stroke="#FFC107"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span className="ml-1 text-[13px]">
                          {review.quality_rating}:{review.service_rating}:
                          {review.price_rating}
                        </span>
                      </div>
                    </div>
                    <span className="text-[13px] text-[#777280]">
                      {formatDate(review.created_at)}
                    </span>
                  </div>
                  <p className="mt-2 text-[13px] text-[#232123]">
                    {review.review}
                  </p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Rating Modal */}
      <ReviewModal
        fetcher={fetcher}
        businessDetail={businessDetail}
        open={open}
        setOpen={setOpen}
      />
    </div>
  );
}
